import { render, staticRenderFns } from "./ListApartments.vue?vue&type=template&id=976c5f26"
import script from "./ListApartments.vue?vue&type=script&lang=js"
export * from "./ListApartments.vue?vue&type=script&lang=js"
import style0 from "./ListApartments.vue?vue&type=style&index=0&id=976c5f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports